var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "dining-board" },
    [
      _c("div", { staticClass: "top-bar" }, [
        _c("span", { staticClass: "top-title" }, [_vm._v("餐饮收银台")]),
        _c(
          "div",
          { staticClass: "top-right" },
          [
            _vm.storeName
              ? _c(
                  "span",
                  {
                    staticClass: "top-store",
                    attrs: { title: "点击切换门店" },
                    on: { click: _vm.openStoreModal },
                  },
                  [_vm._v(_vm._s(_vm.storeName))]
                )
              : _vm._e(),
            _c("span", { staticClass: "top-user" }, [
              _vm._v(_vm._s(_vm.userName)),
            ]),
            _c(
              "a-button",
              { attrs: { size: "small" }, on: { click: _vm.handleLogout } },
              [_vm._v("退出登录")]
            ),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "board-body" }, [
        _c("div", { staticClass: "board-main" }, [
          _c(
            "div",
            { staticClass: "board-stats" },
            [
              _c("span", { staticClass: "stat idle" }, [
                _vm._v("空闲 " + _vm._s(_vm.counts.idle)),
              ]),
              _c("span", { staticClass: "stat occupied" }, [
                _vm._v("占用 " + _vm._s(_vm.counts.occupied)),
              ]),
              _c("span", { staticClass: "stat reserved" }, [
                _vm._v("预订 " + _vm._s(_vm.counts.reserved)),
              ]),
              _c("span", { staticClass: "stat parked" }, [
                _vm._v("挂单 " + _vm._s(_vm.parked.length)),
              ]),
              !_vm.loading
                ? _c(
                    "a-button",
                    {
                      staticClass: "refresh-btn",
                      attrs: { size: "small" },
                      on: { click: _vm.refreshAll },
                    },
                    [_vm._v("刷新")]
                  )
                : _c("a-icon", {
                    staticClass: "refresh-btn",
                    attrs: { type: "loading" },
                  }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "area-scroll" },
            [
              _vm._l(_vm.areas, function (area) {
                return _c("div", { key: area.key, staticClass: "area-block" }, [
                  _c("div", { staticClass: "area-title" }, [
                    _vm._v(
                      "\n            " + _vm._s(area.name) + "\n            "
                    ),
                    _c("span", { staticClass: "area-count" }, [
                      _vm._v(_vm._s(area.tables.length) + " 桌"),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "table-grid" },
                    _vm._l(area.tables, function (t) {
                      return _c(
                        "div",
                        {
                          key: t.id,
                          staticClass: "table-card",
                          class: t.status,
                          on: {
                            click: function ($event) {
                              return _vm.onTableClick(t)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "table-head" }, [
                            _c("span", { staticClass: "table-name" }, [
                              _vm._v(_vm._s(t.name)),
                            ]),
                            _c("span", { staticClass: "table-cap" }, [
                              _vm._v(_vm._s(t.capacity || "-") + "人"),
                            ]),
                          ]),
                          t.orderId
                            ? [
                                _c("div", { staticClass: "table-order-no" }, [
                                  _vm._v(_vm._s(t.orderNo)),
                                ]),
                                _vm.amountOf(t.orderId) !== null
                                  ? _c("div", { staticClass: "table-amount" }, [
                                      _vm._v(
                                        "¥" + _vm._s(_vm.amountOf(t.orderId))
                                      ),
                                    ])
                                  : _vm._e(),
                              ]
                            : _c("div", { staticClass: "table-status-text" }, [
                                _vm._v(_vm._s(_vm.statusText(t.status))),
                              ]),
                        ],
                        2
                      )
                    }),
                    0
                  ),
                ])
              }),
              !_vm.loading && _vm.areas.length === 0
                ? _c("div", { staticClass: "board-empty" }, [
                    _vm._v(
                      "\n          暂无桌台，请先在管理端配置桌台\n        "
                    ),
                  ])
                : _vm._e(),
            ],
            2
          ),
        ]),
        _c("div", { staticClass: "board-side" }, [
          _c(
            "div",
            { staticClass: "side-actions" },
            [
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    block: "",
                    icon: "shopping",
                    loading: _vm.creating,
                  },
                  on: { click: _vm.createTakeout },
                },
                [_vm._v("外带单")]
              ),
              _c(
                "a-button",
                {
                  attrs: { block: "", icon: "profile" },
                  on: {
                    click: function ($event) {
                      _vm.manageVisible = true
                    },
                  },
                },
                [_vm._v("订单管理")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "side-title" }, [
            _vm._v("挂单（" + _vm._s(_vm.parked.length) + "）"),
          ]),
          _c(
            "div",
            { staticClass: "parked-scroll" },
            [
              _vm._l(_vm.parked, function (p) {
                return _c(
                  "div",
                  {
                    key: p.id,
                    staticClass: "parked-card",
                    on: {
                      click: function ($event) {
                        return _vm.resumeParked(p)
                      },
                    },
                  },
                  [
                    _c("div", { staticClass: "p-head" }, [
                      _c("span", { staticClass: "p-table" }, [
                        _vm._v(_vm._s(p.tableName || "外带")),
                      ]),
                      _c("span", { staticClass: "p-amount" }, [
                        _vm._v("¥" + _vm._s(_vm.fmt(p.total_amount))),
                      ]),
                    ]),
                    _c("div", { staticClass: "p-no" }, [
                      _vm._v(_vm._s(p.order_no)),
                    ]),
                    _c("div", { staticClass: "p-time" }, [
                      _vm._v(_vm._s(p.update_time)),
                    ]),
                  ]
                )
              }),
              _vm.parked.length === 0
                ? _c("div", { staticClass: "side-empty" }, [_vm._v("暂无挂单")])
                : _vm._e(),
            ],
            2
          ),
        ]),
      ]),
      _vm.manageVisible
        ? _c("OrderManage", {
            attrs: { "store-id": _vm.storeId },
            on: {
              close: function ($event) {
                _vm.manageVisible = false
              },
            },
          })
        : _vm._e(),
      _c(
        "a-modal",
        {
          attrs: {
            title: "选择门店",
            visible: _vm.storeModalVisible,
            footer: null,
            maskClosable: false,
          },
          on: {
            cancel: function ($event) {
              _vm.storeModalVisible = false
            },
          },
        },
        [
          _vm._l(_vm.storeOptions, function (s) {
            return _c(
              "div",
              {
                key: s.id,
                staticClass: "store-pick",
                on: {
                  click: function ($event) {
                    return _vm.pickStore(s)
                  },
                },
              },
              [
                _c("span", { staticClass: "store-pick-name" }, [
                  _vm._v(_vm._s(s.name)),
                ]),
                s.isMain === "1"
                  ? _c("a-tag", { attrs: { color: "blue" } }, [_vm._v("总店")])
                  : _vm._e(),
                _c(
                  "a-tag",
                  { attrs: { color: s.status === "1" ? "green" : "red" } },
                  [_vm._v(_vm._s(s.status === "1" ? "营业" : "停用"))]
                ),
              ],
              1
            )
          }),
          _vm.storeOptions.length === 0
            ? _c("div", { staticClass: "store-pick-empty" }, [
                _vm._v("当前租户尚未创建门店，请先在管理后台创建门店"),
              ])
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }